// portfolioReducer.js

import {
  UPDATE_TITLE,
  UPDATE_CATEGORY,
  UPDATE_SLUG,
  UPDATE_TAGLINE,
  UPDATE_FEATURE_IMAGE,
  UPDATE_TECHNOLOGIES,
  UPDATE_PLATFORM,
  UPDATE_INDUSTRY,
  UPDATE_COUNTRY,
  UPDATE_FIRST_DESC,
  UPDATE_YTVIDEOLINK1,
  UPDATE_YTVIDEOLINK2,
  UPDATE_YTVIDEOLINK3,
  UPDATE_DESC_IMAGE_1,
  UPDATE_DESC_IMAGE_2,
  UPDATE_DESC_IMAGE_3,
  UPDATE_DESC_IMAGE_4,
  UPDATE_HIGHLIGHT_IMAGE,
  UPDATE_META_TITLE,
  UPDATE_META_DESCRIPTION,
} from "./actions.js";

const initialState = {
  slug: "",
  category: "web",
  title: "",
  tagline: "",
  featureImage: [],
  technologies: [],
  platform: "",
  industry: "",
  country: "",
  firstDescription: "",
  youtube1: "",
  youtube2: "",
  youtube3: "",
  descImage1: "",
  descImage2: "",
  descImage3: "",
  descImage4: "",
  highlightImage: "",
  metaTitle: "",
  metaDescription: "",
};

const portfolioReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SLUG:
      return {
        ...state,
        slug: action.payload,
      };
    case UPDATE_CATEGORY:
      return {
        ...state,
        category: action.payload,
      };
    case UPDATE_TITLE:
      return {
        ...state,
        title: action.payload,
      };
    case UPDATE_TAGLINE:
      return {
        ...state,
        tagline: action.payload,
      };
    case UPDATE_FEATURE_IMAGE:
      return {
        ...state,
        featureImage: action.payload,
      };
    case UPDATE_TECHNOLOGIES:
      return {
        ...state,
        technologies: action.payload,
      };
    case UPDATE_PLATFORM:
      return {
        ...state,
        platform: action.payload,
      };
    case UPDATE_INDUSTRY:
      return {
        ...state,
        industry: action.payload,
      };
    case UPDATE_COUNTRY:
      return {
        ...state,
        country: action.payload,
      };
    case UPDATE_FIRST_DESC:
      return {
        ...state,
        firstDescription: action.payload,
      };
    case UPDATE_YTVIDEOLINK1:
      return {
        ...state,
        youtube1: action.payload,
      };
    case UPDATE_YTVIDEOLINK2:
      return {
        ...state,
        youtube2: action.payload,
      };
    case UPDATE_YTVIDEOLINK3:
      return {
        ...state,
        youtube3: action.payload,
      };
    case UPDATE_DESC_IMAGE_1:
      return {
        ...state,
        descImage1: action.payload,
      };
    case UPDATE_DESC_IMAGE_2:
      return {
        ...state,
        descImage2: action.payload,
      };
    case UPDATE_DESC_IMAGE_3:
      return {
        ...state,
        descImage3: action.payload,
      };
    case UPDATE_DESC_IMAGE_4:
      return {
        ...state,
        descImage4: action.payload,
      };
    case UPDATE_HIGHLIGHT_IMAGE:
      return {
        ...state,
        highlightImage: action.payload,
      };
    case UPDATE_META_TITLE:
      return {
        ...state,
        metaTitle: action.payload,
      };
    case UPDATE_META_DESCRIPTION:
      return {
        ...state,
        metaDescription: action.payload,
      };
    default:
      return state;
  }
};

export default portfolioReducer;
